// The register box at the top of a member's This month (Adam, 18 Oct 2026: "I should be able to mark him down as
// attended this session: select the date from a drop-down and mark him as present"). A drop-down of the member's group's
// sessions, today's first and picked when there is one, then the held ones, newest first; Present, Absent and Excused,
// with Excused's hint, agreed in advance (the register's own present, absent and excused, written the way the register
// and the Sessions card write a line: hub.attendance under row level security, so owner, admin, support and a host for
// their product, as the register allows; the database refuses a session that hasn't started). The session picked stays
// as Adam steps Next and Previous, so he goes down the group in 1 go. After a mark, the member's log is read again, so
// Sessions and the strip show it. Once the member is marked for the session picked, the box is 1 line, "Sun 27 Sep:
// absent.", with Change to open it (the critique's admin 3); a mark saved here keeps it open, so it can be put right.
import { useId, useState } from 'react'
import { Button, Card, Field, Select, todayInUk, ukDayOf, useAdmin } from '../ui/index.js'
import { time } from '../../lib/format.js'
import { wdm } from '../../products/mastermind/log.js'
import { MM, registerChoices } from './words.js'
import { setMark } from './data.js'
import { Said } from './ThisMonth.jsx'

const MARKS = ['present', 'absent', 'excused']

export function RegisterBox({ log, person, first, sessions, picked, onPick, onChanged }) {
  const { api } = useAdmin()
  const ids = useId()
  const [busy, setBusy] = useState(null)
  const [line, setLine] = useState(null)
  const [opened, setOpened] = useState(false)
  // what this page saved, by session, so the mark shows at once even for a session the log doesn't list
  const [saved, setSaved] = useState({})
  const today = todayInUk()
  const choices = registerChoices(sessions, { cohortId: log.access?.cohort_id || null, today, dayOf: ukDayOf })
  const session = choices.find(s => s.id === picked) || choices[0] || null
  const labelOf = s => (ukDayOf(s.starts_at) === today ? MM.attendToday : MM.attendWhen)(wdm(s.starts_at), time(s.starts_at))

  if (!session) {
    return (
      <Card id="mm-register" title={MM.attendH} className="amx-register">
        <p className="amx-muted">{MM.attendNone(first)}</p>
      </Card>
    )
  }
  const fromLog = (log.sessions || []).find(s => s.session_id === session.id)
  const mark = saved[session.id] !== undefined ? saved[session.id] : fromLog?.status || null
  const started = Date.parse(session.starts_at) <= Date.now()

  async function go(status) {
    if (busy || status === mark) return
    setLine(null)
    if (Date.parse(session.starts_at) > Date.now()) { setLine({ bad: true, text: MM.attendNotYet(time(session.starts_at)) }); return }
    setBusy(status)
    try {
      await setMark(api, { session: session.id, person, status })
      setSaved(s => ({ ...s, [session.id]: status }))
      setOpened(true)
      await onChanged()
      setLine({ text: MM.markSaved(wdm(session.starts_at), MM.attendMarks[status]) })
    } catch (e) { setLine({ bad: true, text: e.message }) } finally { setBusy(null) }
  }

  // marked: 1 line, with Change
  if (mark && !opened) {
    return (
      <section id="mm-register" className="amx-register-line" aria-label={MM.attendH}>
        <span className="amx-register-line-text">{MM.attendFolded(wdm(session.starts_at), MM.attendMarks[mark])}</span>
        <Button size="xs" aria-expanded={false} onClick={() => setOpened(true)}>{MM.attendChange}</Button>
      </section>
    )
  }

  return (
    <Card id="mm-register" title={MM.attendH} className="amx-register">
      <p className="amx-muted">{MM.attendLede(first)}</p>
      <div className="amx-register-row">
        <Field label={MM.attendSession} plain>
          {props => (
            <Select {...props} value={session.id} disabled={Boolean(busy)}
              onChange={v => { setLine(null); onPick(v) }}
              options={choices.map(s => ({ value: s.id, label: labelOf(s) }))} />
          )}
        </Field>
        <div className="amx-marks amx-register-marks" role="group" aria-label={MM.attendLabel(first)} aria-describedby={`${ids}-hint`}>
          {MARKS.map(m => (
            <Button key={m} size="sm" kind={mark === m ? 'ink' : 'line'} aria-pressed={mark === m} busy={busy === m}
              disabled={Boolean(busy) && busy !== m} onClick={() => go(m)}>{MM.attendMarks[m]}</Button>
          ))}
        </div>
      </div>
      <p className="amx-muted" id={`${ids}-hint`}>{MM.excusedHint}</p>
      <p className="amx-register-now" id={`${ids}-now`}>{MM.attendNow(first, mark ? MM.attendMarks[mark] : null)}</p>
      {!started && !line && <p className="amx-muted">{MM.attendNotYet(time(session.starts_at))}</p>}
      <Said line={line} />
    </Card>
  )
}
